import { Injectable } from '@angular/core';
import { WebApi } from 'app/core/web-api.service';

const API_URL = '/api';

@Injectable()
export class Api extends WebApi {
    /** Возвращает url запроса к api */
    protected _getUrl(url: string): string {
        return `${API_URL}${url}`;
    }
}

